<template>
    <select @change="onChange()" ref="unitSelect">
        <option v-for="unit in currentPlacingUnits" :value="unit.unit.id" :key="unit.unit.id"> {{unit.unit.name}} ({{unit.count}})</option>
    </select>
</template>

<script>
export default {
    data(){
        return{
            currentPlacingUnits: this.game.redPlacingUnits,
        }
    },
    methods: {
        updateUnitList(value){
            this.currentPlacingUnits = [...value];
            this.onChange();
        },
        onChange(){
            this.game.setPlacingUnit(this.$refs.unitSelect.value);
        },
    },
    props: {
        units: {
            type: Array,
            required: true
        }
    },
    inject: ["game"],
    created() {
        this.game.updaters.unitSelector = this.updateUnitList;
    },
}
</script>

<style>

</style>